import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnChanges, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
//import { NgxMasonryOptions } from 'ngx-masonry';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem, SelectItem } from 'primeng/api';
import { SocialPost } from 'src/app/models/socialpost.model';
// import { SocailPostApiResponce } from 'src/app/models/socialpost.model';
import { artistProduct, ArtistProductsService, ArtistProductsSummaryRequest, ConsignedProductsRequest } from 'src/app/Services/artistproducts.service';
import { Artist } from 'src/app/Services/artists.service';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { ConnectionsService } from 'src/app/Services/connections.service';
import { ConsignmentService, GalleryConsignmentProduct } from 'src/app/Services/consignment.service';
import { ProductRequest } from 'src/app/Services/product-request-queue.service';
import { FilterSocialPostApi, SocialPostService } from 'src/app/Services/social-post.service';
// import { NgxMasonryComponent } from 'ngx-masonry';
// import { ViewChild } from '@angular/core';

@Component({
    selector: 'app-product-social-media-shares',
    templateUrl: './product-social-media-shares.component.html',
    styleUrls: ['./product-social-media-shares.component.css'],
    standalone: false
})
export class ProductSocialMediaSharesComponent implements OnInit {
  // @ViewChild(NgxMasonryComponent) masonry!: NgxMasonryComponent;
  public socialPosts: SocialPost[] = [
    {
      Id: "",
      PostId: "",
      PostedOn: "",
      HeadLine: "",
      Description: "",
      ImageURL: "",
      UserId: "",
      CreatedDate: new Date(),
      SocialMediaInsights: {
        TotalLikes: 0,
        TotalShares: 0,
        TotalComments: 0
      },
      FacebookAccount: {
        FacebookProfileName: "",
        FacebookProfilePicture: "",
        FaceBookPageId: "",
        PageIsActive: false,
        FacebookPageName: "",
        FacebookPagePicture: "",
        PageAccessTokken: ""
      },
      InstagramAccount: {
        PageIsActive: false,
        InstagramPageId: "",
        InstagramPageName: "",
        InstagramPagePicture: "",
        PageAccessTokken: "",
      },
      UserName: "",
      UserBusinessName: "",
      UserEmail: "",
      UserImgUrl: "",
      ProductId: "",
      IsArtist: false,
      ProductName: "",
      PostedBy: "",
      ArtistId: ""
    }
  ];
  public artistPosts: SocialPost[] = [
    {
      Id: "",
      PostId: "",
      PostedOn: "",
      HeadLine: "",
      Description: "",
      ImageURL: "",
      UserId: "",
      CreatedDate: new Date(),
      SocialMediaInsights: {
        TotalLikes: 0,
        TotalShares: 0,
        TotalComments: 0
      },
      FacebookAccount: {
        FacebookProfileName: "",
        FacebookProfilePicture: "",
        FaceBookPageId: "",
        PageIsActive: false,
        FacebookPageName: "",
        FacebookPagePicture: "",
        PageAccessTokken: ""
      },
      InstagramAccount: {
        PageIsActive: false,
        InstagramPageId: "",
        InstagramPageName: "",
        InstagramPagePicture: "",
        PageAccessTokken: "",
      },
      UserName: "",
      UserBusinessName: "",
      UserEmail: "",
      UserImgUrl: "",
      ProductId: "",
      IsArtist: false,
      ProductName: "",
      PostedBy: "",
      ArtistId: ""
    }
  ];
  public galleryPosts: SocialPost[] = [
    {
      Id: "",
      PostId: "",
      PostedOn: "",
      HeadLine: "",
      Description: "",
      ImageURL: "",
      UserId: "",
      CreatedDate: new Date(),
      SocialMediaInsights: {
        TotalLikes: 0,
        TotalShares: 0,
        TotalComments: 0
      },
      FacebookAccount: {
        FacebookProfileName: "",
        FacebookProfilePicture: "",
        FaceBookPageId: "",
        PageIsActive: false,
        FacebookPageName: "",
        FacebookPagePicture: "",
        PageAccessTokken: ""
      },
      InstagramAccount: {
        PageIsActive: false,
        InstagramPageId: "",
        InstagramPageName: "",
        InstagramPagePicture: "",
        PageAccessTokken: "",
      },
      UserName: "",
      UserBusinessName: "",
      UserEmail: "",
      UserImgUrl: "",
      ProductId: "",
      IsArtist: false,
      ProductName: "",
      PostedBy: "",
      ArtistId: ""
    }
  ];
  public filter: FilterSocialPostApi = {};
  public authConfig!: AuthConfig;
  public items: MenuItem[] | undefined;
  public home: MenuItem | undefined;
  public userId: string | null = null;
  public userOptions: SelectItem[] = [];
  public ProductName: SelectItem[] = [];
  public galleries: SelectItem[] = [];
  public artists: SelectItem[] = [];
  public artistProdusts: SelectItem[] = [];
  public galleryProducts: SelectItem[] = [];
  public artistId!: string;
  public isArtist: boolean = false;
  public isGallery: boolean = false;
  public isExpanded: boolean = false
  public isAuthenticated!: boolean;
  public galleryId!: string;
  public selectedTabIndex: number = 0;
  maxDescriptionLength = 40; // Maximum characters for the short description
  isDescriptionExpanded: boolean[] = []; // To track the state of each post's description
  public platformBrowser: boolean = false;
  public filterByFacebook: boolean = false;
  public filterByInstagram: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private ngxSpinnerService: NgxSpinnerService,
    private socialPostService: SocialPostService,
    private authService: AuthService,
    private router: Router,
    private connectionsService: ConnectionsService,
    private route: ActivatedRoute,
    private artistProduct: ArtistProductsService,
    private consignmentService: ConsignmentService
  ) {
    this.platformBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.platformBrowser){
        this.userId = this.authService.getUserId();
        this.isAuthenticated = this.authService.isAuthenticated();
        this.route.params.subscribe((params) => {
          if (params['artistId']) {
            this.artistId = params['artistId'];
          }
        });
        if (this.isAuthenticated) {
          this.authConfig = this.authService.getAuthConfig();
          if (this.authConfig.IsArtist) {
            this.artistId = this.authService.getUserId();
            this.selectedTabIndex = 0
            this.fetchConnectedGalleries(this.artistId, false);
            this.getArtistfilteringProducts();
          }

          if (this.authConfig.IsGallery) {
            this.galleryId = this.authService.getUserId();
            this.selectedTabIndex = 1
            this.getConnectedArtists(this.galleryId)
            this.getGalleryConsignmentProducts(this.artistId);
          }

          if (this.userId) {
            this.getSocialPosts();
          }
          this.isArtist = this.authConfig.IsArtist || false;
          this.isGallery = this.authConfig.IsGallery || false;

          this.artistPosts.forEach((_, index) => {
            this.isDescriptionExpanded[index] = false;
          });

          this.galleryPosts.forEach((_, index) => {
            this.isDescriptionExpanded[index] = false;
          });
        }
    }
    

  }

  public onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/No-Image.png';
}


  private getArtistfilteringProducts() {
    this.artistProduct.getArtistProductforFiltering().subscribe((artistProduct) => {
      this.artistProdusts = artistProduct.map((artist) => { return { label: artist.Name, value: artist.Id } });
    })
  }

  private getGalleryConsignmentProducts(artistId: string | null = null, filters: ConsignedProductsRequest = {}) {
    this.ngxSpinnerService.show();
    this.consignmentService.getGalleryConsignmentProducts(artistId, filters).subscribe((galleryProducts: GalleryConsignmentProduct[]) => {
      this.galleryProducts = galleryProducts.map((gallery) => { return { label: gallery.Product.Name, value: gallery.Product.Id } });
      this.ngxSpinnerService.hide();
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });

  }

  public onArtistProductsChange($event: SelectItem) {
    // this.productId = null
    if ($event.value) {
      this.filter.productId = $event.value
      this.getSocialPosts(this.filter.productId)
    } else {
      this.clearAllFilters();
      // this.filter.productId = ''
      // this.getSocialPosts();
    }
  }

  public onGalleryProductsChange($event: SelectItem) {
    if ($event.value) {
      this.filter.productId = $event.value
      this.getSocialPosts(this.filter.productId)
    } else {
      this.clearAllFilters();
      // this.filter.productId = ''
      // this.getSocialPosts();
    }
  }

  private fetchConnectedGalleries(artistId: string, includeInvited: boolean) {
    this.connectionsService.getConnectedGalleries(artistId, includeInvited).subscribe((galleries) => {
      this.galleries = galleries.map((gallery) => { return { label: gallery.Name, value: gallery.Id } });
    }, (error) => { console.error(error); });
  }

  private getConnectedArtists(galleryId: string | null = null, filters: ArtistProductsSummaryRequest = {}) {
    this.ngxSpinnerService.show();
    this.connectionsService.getConnectedArtists(galleryId, true, filters).subscribe((artists: Artist[]) => {
      this.artists = artists.map((artist) => { return { label: artist.Name, value: artist.Id } });;
      this.ngxSpinnerService.hide();
    }, (error) => { console.error('Error fetching connected Artist:', error); this.ngxSpinnerService.hide(); });
  }

  public onGalleriesChange($event: SelectItem) {
    if ($event.value) {
      this.filter.filterUserId = $event.value;
      console.log(this.filter.filterUserId)
      this.selectedTabIndex = 1
      this.getSocialPosts(this.filter.productId, this.filter.filterUserId);
    } else {
      this.selectedTabIndex = 0
      this.clearAllFilters();
      // this.selectedTabIndex = 0
      // this.getSocialPosts();
    }
  }

  public onArtistsChange($event: SelectItem) {
    if ($event.value) {
      console.log($event.value)
      this.selectedTabIndex = 0
      this.filter.filterUserId = $event.value;
      console.log(this.filter.filterUserId)
      this.getSocialPosts(this.filter.productId, this.filter.filterUserId);
    } else {
      this.selectedTabIndex = 1
      // this.filter.filterUserId = '';
      // this.getSocialPosts();
      this.clearAllFilters();
    }
  }

  public getSocialPosts(productId?: string | null, filterUserId?: string | null): void {
    if (!this.platformBrowser) return;
    const selectedProductId = productId ? productId : null;
    const selectedUserId = filterUserId ? filterUserId : null;
    this.ngxSpinnerService.show();
    this.socialPostService.getAllSocailPost(selectedProductId, selectedUserId).subscribe(
      (response: SocialPost[]) => {
        this.socialPosts = response;
        console.log(this.socialPosts)
        this.filterPosts();
        this.items = [{ label: 'Product Social Media Shares' }];
        this.home = { icon: 'pi pi-home', routerLink: '/' };
        this.ngxSpinnerService.hide();
      },
      (error) => {
        console.error('Error fetching social posts:', error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  private filterPosts(): void {
    this.artistPosts = this.socialPosts.filter(post => post.IsArtist);
    console.log("artistPosts",this.artistPosts)
    this.galleryPosts = this.socialPosts.filter(post => !post.IsArtist);
    console.log("galleryPosts",this.galleryPosts)
  }

  public filterSocialPosts(type: 'artist' | 'gallery', platform: 'Facebook' | 'Instagram', event: any): void {
    console.log(`${platform} filter applied for ${type}:`, event.checked);
    if (platform === 'Facebook') {
      this.filterByFacebook = event.checked;
    } else if (platform === 'Instagram') {
      this.filterByInstagram = event.checked;
    }
    if ((!this.filterByFacebook && !this.filterByInstagram) || (this.filterByFacebook && this.filterByInstagram)) {
      this.filterPosts();
      return;
    }
    if (type === 'artist') {
      this.artistPosts = this.artistPosts.filter(post =>
        (this.filterByFacebook && post.PostedOn === 'Facebook') ||
        (this.filterByInstagram && post.PostedOn === 'Instagram')
      );
      console.log('Filtered artist posts:', this.artistPosts);
    } else {
      this.galleryPosts = this.galleryPosts.filter(post =>
        (this.filterByFacebook && post.PostedOn === 'Facebook') ||
        (this.filterByInstagram && post.PostedOn === 'Instagram')
      );
      console.log('Filtered gallery posts:', this.galleryPosts);
    }
  }

  public goToProductDetails(product: SocialPost) {
    console.log(product)
    if (!product.ArtistId || !product.ProductId) {
      console.error('Invalid route parameters:', product);
      return;
    }
    this.router.navigate(['/', product.ArtistId, 'artworks', product.ProductId]);
  }

  public clearAllFilters() {
    this.filter = {}
    this.getSocialPosts(this.filter.productId, this.filter.filterUserId);
  }

  getShortDescription(description: string): string {
    return description.length > this.maxDescriptionLength
      ? `${description.substring(0, this.maxDescriptionLength)}.`
      : description;
  }

  toggleDescription(index: number, event: Event): void {
    event.preventDefault();
    this.isDescriptionExpanded[index] = !this.isDescriptionExpanded[index];
    console.log(this.isDescriptionExpanded)
  }

  calculateHeight(post: SocialPost): { height: string } {
    const baseheight = '220px';
    const additionalheight = post.Description ? post.Description.length + 'px' : '0';
    const dynamicheight = 'calc(' + baseheight + ' + ' + additionalheight + ')';

    return { height: dynamicheight };
  }

  public onTabChange(event: any) {
    this.filterByFacebook = false
    this.filterByInstagram = false
    if (this.platformBrowser && typeof window !== 'undefined') {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 0);
    }

    console.log(event)
    if (event.index == 0) {

      this.selectedTabIndex = event.index;
      this.artistPosts = this.socialPosts.filter(post => post.IsArtist);
    } else if (event.index === 1) {
      this.selectedTabIndex = event.index;
      this.galleryPosts = this.socialPosts.filter(post => !post.IsArtist);
    }


  }

  getProfilePicture(post: any): string {
    if (post.FacebookAccount && post.FacebookAccount.FacebookProfilePicture) {
      return post.FacebookAccount.FacebookProfilePicture;
    } else if (post.InstagramAccount && post.InstagramAccount.InstagramPagePicture) {
      return post.InstagramAccount.InstagramPagePicture;
    } else {
      return "assets/images/No-Image.png";
    }
  }

  getProfileName(post: any): string {
    if (post.FacebookAccount && post.FacebookAccount.FacebookProfileName) {
      return post.FacebookAccount.FacebookProfileName;
    } else if (post.InstagramAccount && post.InstagramAccount.InstagramPageName) {
      return post.InstagramAccount.InstagramPageName;
    } else {
      return "Anonymous";
    }
  }

}
